import { render, staticRenderFns } from "./HomeUnidades.vue?vue&type=template&id=023334b8&scoped=true&"
import script from "./HomeUnidades.vue?vue&type=script&lang=js&"
export * from "./HomeUnidades.vue?vue&type=script&lang=js&"
import style0 from "./HomeUnidades.vue?vue&type=style&index=0&id=023334b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023334b8",
  null
  
)

export default component.exports